// extracted by mini-css-extract-plugin
export default {"wrapper":"TextSide_wrapper__TYgLI","title":"TextSide_title__AxJJZ","description":"TextSide_description__pqVoo"};